// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AgentExecutionStatusSchema = z.enum(['PENDING','RUNNING','COMPLETED','FAILED','ABORTED','BLOCKED'] as const);

export type AgentExecutionStatusType = `${z.infer<typeof AgentExecutionStatusSchema>}`

export default AgentExecutionStatusSchema;
